exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mint-toast{position:fixed;max-width:80%;border-radius:5px;background:rgba(0,0,0,.7);color:#fff;box-sizing:border-box;text-align:center;z-index:1000;transition:opacity .3s linear}.mint-toast.is-placebottom{bottom:50px;left:50%;transform:translate(-50%)}.mint-toast.is-placemiddle{left:50%;top:50%;transform:translate(-50%,-50%)}.mint-toast.is-placetop{top:50px;left:50%;transform:translate(-50%)}.mint-toast-icon{display:block;text-align:center;font-size:56px}.mint-toast-text{font-size:14px;display:block;text-align:center}.mint-toast-pop-enter,.mint-toast-pop-leave-active{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/bh-mint-ui2/lib/toast/style.css
// module id = 152
// module chunks = 0